import { Component, OnInit, Inject, ViewChild, Input } from '@angular/core';
import { MAT_DIALOG_DATA,
  MatDialogRef,
  MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY,
  MatTableDataSource,
  MatListOption,
  MatSelectionList} from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { FsService } from '../../fs.service';
import { ShiftsService } from '../../shifts.service';
import { TransactionService } from '../../transaction.service';

@Component({
  selector: 'app-add-fs',
  templateUrl: './add-fs.component.html',
  styleUrls: ['./add-fs.component.scss']
})
export class AddFsComponent implements OnInit {

  columns: any = ['name'];
  fss: any = [];
  fsOg: any = [];
  shifts: any = [];
  selectedFs: any = [];
  selectedShift = '';
  siteName = '';
  siteId = '';
  @ViewChild(MatSelectionList) fsMatList: MatSelectionList;

  constructor(
    public dialogRef: MatDialogRef<AddFsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fsService: FsService,
    private shiftService: ShiftsService,
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.siteName = this.data.site;
    this.siteId = this.data.siteId;
    this.fss = this.fsOg;
    this.fsMatList.selectedOptions = new SelectionModel(false);
    this.getSupervisorList();
    this.getShifts(this.siteName);
  }

  getSupervisorList() {
    this.fsService.getSupervisorList()
      .subscribe((data) => {
        this.fsOg = data;
        this.applyFsFilter('');
    });
  }

  getShifts(site: string) {
    this.shiftService.getShifts(site)
      .subscribe((data) => {
        this.shifts = data;
      });
  }

  addClicked() {
    if (this.selectedFs.length === 0) {
      alert('You must select a Shift Leader to allocate');
      return;
    }
    if (this.selectedShift === '') {
      alert('You must select a shift to allocate');
      return;
    }
    this.saveFs();
  }

  closeClicked() {
    this.dialogRef.close();
  }

  applyFsFilter(filterValue: string) {
    this.fss = this.fsOg;
    const searchArr = filterValue.trim().split(' ');
    this.fss = Object.assign([], this.fsOg).filter(
      item => {
        if (filterValue === '') {
          return true;
        }
        let hit = 0;
        const itemDetails = item.name.trim();
        const itemId = item.id;
        searchArr.forEach(searchTerm => {
          if (itemDetails.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || itemId.toString().indexOf(searchTerm) > -1) {
            hit++;
          }
        });
        if (hit === searchArr.length) {
          return true;
        } else {
          return false;
        }
      }
    );
  }

  assignFs(fs: any) {
    if (this.fsMatList.selectedOptions.selected.length === 0) {
      this.selectedFs = [];
    } else {
      this.selectedFs = [fs];
    }
  }

  onShiftChange(shift: any) {
    this.selectedShift = shift;
  }

  saveFs() {
    this.fsService.addSupervisor(this.siteId, this.selectedShift, this.selectedFs[0].id, localStorage.getItem('userFullName'))
    .subscribe(([data]: any) => { // [data] would be data[0]
      // creating a new supervisor from client side without refreshing
      // some data can't be added like: email, phone, siteAddress, agencyRequirements
      const supervisor = {
        amEndH: 15,
        amEndM: 0,
        amStartH: 6,
        amStartM: 30,
        c1label: 'DAY',
        c2label: 'AFTERNOON',
        c3label: 'MIDNIGHT',
        c4EndH: 0,
        c4EndM: 0,
        c4StartH: 0,
        c4StartM: 0,
        c4label: '',
        c5EndH: 0,
        c5EndM: 0,
        c5StartH: 0,
        c5StartM: 0,
        c5label: '',
        c6EndH: 0,
        c6EndM: 0,
        c6StartH: 0,
        c6StartM: 0,
        c6label: '',
        id: this.selectedFs[0].id,
        isFri: 1,
        isMon: 1,
        isSat: 0,
        isSun: 0,
        isThurs: 1,
        isTues: 1,
        isWed: 1,
        itemId: Number(data.id),
        mnEndH: 7,
        mnEndM: 0,
        mnStartH: 22,
        mnStartM: 30,
        name: this.selectedFs[0].name,
        pmEndH: 23,
        pmEndM: 0,
        pmStartH: 14,
        pmStartM: 30,
        shift: this.selectedShift
      };

      this.dialogRef.close({
        supervisor
      });

      this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift,
      'Shift Leader ' + this.selectedFs[0].name + ' added to the ' + this.selectedShift + ' shift at ' + this.siteName)
        .subscribe((tdata) => {
        }
      );
    });
  }

}
